import * as z from 'zod';

import { priceFrequencyQueryLinkerSchema } from '@/_pages/settings/price-frequencies/shared/schemas/price-frequency-query-linker-schema';
import { unitSellBysQueryLinkerSchema } from '@/_pages/settings/unit-sell-bys/shared/schemas';
import { currencyInput, numericBooleanQuerySchema, paginatedResponseSchema } from '@/_schemas/generic';

export const productAndServicesQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
  sku: z.string(),

  description: z.string().nullable(),
  list_price: currencyInput.querySchema(),
  client_opt: numericBooleanQuerySchema(),
  price_frequency: priceFrequencyQueryLinkerSchema,
  unit_sell_by: unitSellBysQueryLinkerSchema,

  wholesale_price: currencyInput.querySchema(),
});

export type ProductAndServicesQueryLinkerSchema = z.infer<typeof productAndServicesQueryLinkerSchema>;

export const productAndServicesAllQueryLinkerSchema = paginatedResponseSchema(productAndServicesQueryLinkerSchema);

export type ProductAndServicesAllQueryLinkerSchema = z.infer<typeof productAndServicesAllQueryLinkerSchema>;
